export type WeightsState = 'empty' | 'ok' | 'incomplete' | 'bad';

/** Totals the raw input strings of one block (`''` = blank). */
export function weightsTotal(values: string[]): { total: number; state: WeightsState } {
  const filled = values.filter((v) => v.trim() !== '');
  if (filled.length === 0) return { total: 0, state: 'empty' };
  const nums = filled.map(Number);
  const total = nums.reduce((a, b) => a + b, 0);
  if (nums.some((n) => !Number.isInteger(n) || n < 0 || n > 100)) return { total, state: 'bad' };
  if (filled.length < values.length) return { total, state: 'incomplete' };
  return { total, state: total === 100 ? 'ok' : 'bad' };
}

export const asArray = <T = any>(v: unknown): T[] => (Array.isArray(v) ? v : []);

export function allWeighted<T extends { weight?: unknown }>(items: T[]): boolean {
  return items.length > 0 && items.every((i) => Number.isInteger(i.weight));
}

/** Weighted gradebox fields of a form structure, or null when unweighted. */
export function formWeightsOf(structure: unknown): { title: string; weight: number }[] | null {
  const fields = asArray(structure).filter((f) => f?.type === 'gradebox');
  if (!allWeighted(fields)) return null;
  return fields.map((f) => ({ title: f.title, weight: f.weight }));
}
